import type { UnpublishedReason } from '@/blocks/application/hooks/useCreateAndPublishBlock';
import {
  NEW_BLOCK_DRAFT_NO_CONTENT_MESSAGE,
  NEW_BLOCK_DRAFT_PUBLISH_FAILED_MESSAGE
} from '@/blocks/presentation/constants/draftApiMessages';
import { blockEditorNoticeState } from '@/blocks/presentation/hooks/useBlockEditorNoticeHandoff';

/**
 * The editor's opening note for a New block that was created but not published: calm tone (info when
 * there is simply nothing to publish yet, warning when a failure is worth retrying), never an error —
 * the block exists and the author carries on in the editor.
 */
export function newBlockDraftNoticeState(reason: UnpublishedReason) {
  return blockEditorNoticeState(
    reason === 'no-content'
      ? { message: NEW_BLOCK_DRAFT_NO_CONTENT_MESSAGE, tone: 'info' }
      : { message: NEW_BLOCK_DRAFT_PUBLISH_FAILED_MESSAGE, tone: 'warning' }
  );
}
